import { Chip, Skeleton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useGetDashboardsUsageLimit } from '@/api/REST/dashboards';
import { IconedExternalLink } from '@/components/ui/IconedExternalLink';
import { urls } from '@/constants/externalUrls';
import { useLocaleStore } from '@/stores/locale';

export const DashboardUsageLimitChip = ({
  type,
}: {
  type: 'user' | 'shared';
}) => {
  const { t } = useTranslation('dashboardsOverview');
  const { lang } = useLocaleStore();

  const {
    data: usageLimitState,
    isLoading,
    isError,
  } = useGetDashboardsUsageLimit();

  if (isLoading) {
    return <Skeleton variant="pilled" width={38} height={18} />;
  }

  if (isError) {
    return (
      <Tooltip title={t('usageLimit.LoadingError')}>
        <Chip size="small" label="?/?" color="error" monoText />
      </Tooltip>
    );
  }

  const usageLimitStateForType =
    type === 'user' ? usageLimitState?.user : usageLimitState?.shared;

  const label = `${usageLimitStateForType?.currentCount ?? '?'}/${usageLimitStateForType?.limit ?? '?'}`;

  let chipColor;
  if (usageLimitStateForType?.canCreate) {
    if (
      usageLimitStateForType.currentCount + 1 ===
      usageLimitStateForType.limit
    ) {
      chipColor = 'warning';
    } else {
      chipColor = 'purple';
    }
  } else {
    chipColor = 'error';
  }

  return (
    <Tooltip
      title={
        <>
          {`${t('usageLimit.Tooltip', {
            count: usageLimitStateForType?.limit,
          })} `}
          <IconedExternalLink href={urls.helpCenter.base(lang)} />
        </>
      }
    >
      <Chip
        size="small"
        label={label}
        color={chipColor}
        variant={chipColor === 'warning' ? 'outlined' : 'filled'}
        monoText
      />
    </Tooltip>
  );
};
